const validateField = $field => {
  const fieldValue = $field.value;
  $field.classList.remove('field__input--success');
  if ($field.dataset.required && $field.dataset.required === 'true' && fieldValue.length === 0) {
    $field.classList.add('field__input--error');
    return $field.dataset.errorRequired;
  } else if ($field.dataset.min && fieldValue.length > Number($field.dataset.min)) {
    $field.classList.add('field__input--error');
    return $field.dataset.errorMin;
  } else if ($field.dataset.max && fieldValue.length < Number($field.dataset.max)) {
    $field.classList.add('field__input--error');
    return $field.dataset.errorMax;
  } else if ($field.dataset.pattern && !new RegExp($field.dataset.pattern).test(fieldValue)) {
    $field.classList.add('field__input--error');
    return $field.dataset.errorPattern;
  }
  $field.classList.remove('field__input--error');
  $field.classList.add('field__input--success');
  return false;

}

const validatePassword = $field => {
  let isValid = true;
  $field.nextElementSibling.querySelectorAll('.field__password-validation-condition').forEach($condition => {
    if ($condition.dataset.pattern) {
      const fieldValue = $field.value;
      if (new RegExp($condition.dataset.pattern).test(fieldValue)) {
        $field.classList.remove('field__input--error');
        $condition.classList.add('field__password-validation-condition-success');
      } else {
        $field.classList.add('field__input--error');
        $condition.classList.remove('field__password-validation-condition-success');
        isValid = false;
      }

    } else if ($condition.dataset.match) {
      const $matchField = document.getElementById($condition.dataset.match);
      if ($field.value.length > 0 && $field.value === $matchField.value) {
        $field.classList.remove('field__input--error');
        $condition.classList.add('field__password-validation-condition-success');
      } else {
        $field.classList.add('field__input--error');
        $condition.classList.remove('field__password-validation-condition-success');
        isValid = false;
      }
    }
  });
  if (isValid) {
    $field.classList.remove('field__input--error');
    $field.classList.add('field__input--success');
  } else {
    $field.classList.add('field__input--error');
    $field.classList.remove('field__input--success');
  }
}

const validateSelect = $field => {
  if ($field.dataset.required && $field.dataset.required === 'true' && $field.value === '') {
    $field.classList.add('field__input--error');
    $field.classList.remove('field__input--success');
    return $field.dataset.errorRequired;
  }
  $field.classList.add('field__input--success');

}

const toggleError = ($field, error) => {
  const $errorContainer = $field.nextElementSibling;
  if (error && error.length) {
    $errorContainer.innerHTML = error;
    $errorContainer.classList.add('field__msg--active');
  } else {
    $errorContainer.innerHTML = '';
    $errorContainer.classList.remove('field__msg--active');
  }
}

const disableButton = $button => {
  $button.disabled = true;
}

const enableButton = $button => {
  $button.disabled = false;
}

const checkErrors = $form => {
  let isValid = true;
  if ($form.querySelector('.field__input--error') !== null) {
    isValid = false;
  }
  $form.querySelectorAll('.field__input').forEach($field => {
    if ($field.dataset.required && $field.dataset.required === 'true' && $field.value.length === 0) {
      isValid = false;
    }
  });
  $form.querySelectorAll('.field__select').forEach($field => {
    if ($field.dataset.required && $field.dataset.required === 'true' && $field.value.length === 0) {
      isValid = false;
    }
  });

  $form.querySelectorAll('.field-checkbox').forEach($field => {
    if ($field.dataset.required && $field.dataset.required === 'true' && $field.checked === false) {
      isValid = false;
    }
  });
  return isValid;
}

const getJSON = (endpoint, data) => {
  return new Promise(((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    //if we have data to send, POST, otherwise, GET
    if (data !== false && typeof (data) !== 'undefined') {
      xhr.open('post', endpoint, true);
      xhr.setRequestHeader('Content-type', 'application/json');
    } else {
      xhr.open('get', endpoint, true);
    }
    xhr.responseType = 'json';
    xhr.onload = function() {
      const status = xhr.status;
      if (status === 200) {
        if (typeof xhr.response === 'string') {
          resolve(JSON.parse(xhr.response));
        } else {
          resolve(xhr.response);
        }
      } else {
        reject(status);
      }
    };
    if (data !== false && typeof (data) !== 'undefined') {
      xhr.send(data);
    } else {
      xhr.send();
    }
  }));
}

const serializeform = $form => {
  const obj = {};
  const elements = $form.querySelectorAll('input, select, textarea, button');
  for (let i = 0; i < elements.length; ++i) {
    const element = elements[i];
    const name = element.name;
    const value = element.value;


    if (name) {
      if (element.type === 'radio' || element.type === 'checkbox') {
        if (element.checked) {
          obj[name] = value;
        }
      } else {
        obj[name] = value;
      }
    }
  }

  return JSON.stringify(obj);
}

export {
  validateField,
  toggleError,
  disableButton,
  enableButton,
  checkErrors,
  validatePassword,
  validateSelect,
  getJSON,
  serializeform
};
